
 <!-- <div class="spinner" *ngIf="loading">

    <div class="spinner-img">
  
        <img src="../../../../assets/images/CFO_symbol_white.png" alt="">
  
    </div>
  
  </div> -->

  <ng-container *ngIf="loaderType === 0">
    No loader created
  </ng-container>

<ng-container *ngIf="loaderType === 1">
  <div class="fb-item">
		<div class="first-section-wrapper">
			<div class="gravatar">
				<ngx-skeleton-loader appearance="circle" [theme]="{ width: '80px', height: '80px' }">
				</ngx-skeleton-loader>
			</div>
			<div class="gravatar-title">
				<div>
					<ngx-skeleton-loader [theme]="{
          width: '200px',
          'border-radius': '0',
          height: '15px',
          'margin-bottom': '10px'
        }"></ngx-skeleton-loader>
				</div>
				<div>
					<ngx-skeleton-loader [theme]="{ width: '170px', 'border-radius': '0', height: '15px' }">
					</ngx-skeleton-loader>
				</div>
			</div>
		</div>
		<div class="second-section-wrapper">
			<div class="wrapper">
				<ngx-skeleton-loader [theme]="{
        width: '80%',
        'border-radius': '0',
        height: '15px',
        'margin-bottom': '10px'
      }"></ngx-skeleton-loader>
			</div>
			<div class="wrapper">
				<ngx-skeleton-loader [theme]="{
        width: '90%',
        'border-radius': '0',
        height: '15px',
        'margin-bottom': '10px'
      }"></ngx-skeleton-loader>
			</div>
			<div class="wrapper">
				<ngx-skeleton-loader [theme]="{
        width: '60%',
        'border-radius': '0',
        height: '15px',
        'margin-bottom': '10px'
      }"></ngx-skeleton-loader>
			</div>
		</div>
	</div>

</ng-container>


<ng-container *ngIf="loaderType === 2">
 <!-- Line skeletons with theming -->
  <div class="item">
		<ngx-skeleton-loader count="5" [theme]="{ 'border-radius': '0', height: '50px' }"></ngx-skeleton-loader>
	</div>
</ng-container>


<ng-container **ngIf="loaderType === 3">
  <!-- square skeleton with theming -->
  <div class="item">
		<ngx-skeleton-loader count="5" appearance="circle" [theme]="{
    width: '70px',
    height: '70px',
    'border-radius': '10px'
  }">
		</ngx-skeleton-loader>
	</div>
</ng-container>


<ng-container **ngIf="loaderType === 4">
<!-- Circle skeleton -->
<div class="item">
  <ngx-skeleton-loader count="5" appearance="circle"> </ngx-skeleton-loader>
</div>
</ng-container>